import "./creatChatModalLight.css";
import "./creatChatModalDark.css";

import { Switch } from '@chakra-ui/react'
import { useEffect, useRef, useState } from "react";
import CreatChatButton from "../creatChatButton/creatChatButton";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import AddingParticipants from "../AddingParticipants/addingParticipants";
import { getItemChatAction } from "../../../../redux/reducer/getChatItem/action/action";
import { useLocation, useNavigate } from "react-router";
import { Avatar, AvatarBadge, AvatarGroup } from '@chakra-ui/react'

export default function CreatChatModal(params) {
    const [value, setValue] = useState('1');
    const [load, setLoad] = useState(false);
    const openModal = useRef();
    const getDarkModoe = useSelector(darkModes => darkModes);
    const [isPublic, setisPublic] = useState(false);
    const [openModalForAddEmploys, setOpenModalForAddEmploys] = useState(false)
    const [chatIsClosedSweetch, setChatIsClosedSweetch] = useState(false);
    const getChatInfo = useSelector(chatInfi => chatInfi.getChatInfoByIDReducer);
    const disableDivCanal = useRef();
    const ConversationConnversion = useRef();
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const location = useLocation();
    const [files, setFiles] = useState(null)
    const navigate = useNavigate();

    // открыть модальное окно
    const openModalFunc = () => {
        openModal.current.style.display = "flex";

    }
    // модальная функция закрытия
    const closeModalFunc = () => {

        openModal.current.style = "none";

    }
    // закроем окно modal, если щелкнуть за окном
    const closeModal = (e) => {
        if (e.target.className) {
            if (e.target.className == "creatChatModalContLight" || e.target.className == "creatChatModalContDark") {
                closeModalFunc();
            }
        }
    }
    // модальное закрытие функции завершение===============================================


    // если это публичный чат тогда отключить остальные переключатели
    useEffect(() => {
        if (isPublic) {
            disableDivCanal.current.style.opacity = "0.5";
            ConversationConnversion.current.style.opacity = "0.5";
            ConversationConnversion.current.style.cursor = "no-drop";
            disableDivCanal.current.style.cursor = "no-drop";

        } else {
            disableDivCanal.current.style.opacity = "1";
            ConversationConnversion.current.style.opacity = "1";
            ConversationConnversion.current.style.cursor = "pointer";
            disableDivCanal.current.style.cursor = "pointer";
        }
    }, [isPublic])

    // функция сделать публичным или непубличным
    function sweetch() {
        setisPublic(!isPublic);
    }
    // выбрать изображение
    const handleChange = (e) => {
        if (e.target.name === 'image') {
            setFiles(e.target.files[0])
        }
    }
    // получаем текущую дату для отправления на сервер
    const getCurrentTime = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const day = currentDate.getDate().toString().padStart(2, '0');
        const hours = currentDate.getHours().toString().padStart(2, '0');
        const minutes = currentDate.getMinutes().toString().padStart(2, '0');
        const seconds = currentDate.getSeconds().toString().padStart(2, '0');

        const isoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000+00:00`;
        return isoString;
    }
    // функция для создания чата
    const creatChat = (e) => {
        setLoad(true);
        e.preventDefault();
        let canalOptions = {
            chatName: e.target.chatName.value,
            typeChat: "canal",
            isHiddenChat: false,
            date: getCurrentTime()
        }

        if (isPublic) {
            canalOptions.typeChat = "public";
            canalOptions.isHiddenChat = e.target.hiddenChat.checked;
        } else if (!isPublic && e.target.creatChatType[0].checked) {
            canalOptions.typeChat = "Conversation";
            canalOptions.isHiddenChat = e.target.hiddenChat.checked;
        } else if (!isPublic && e.target.creatChatType[1].checked) {
            canalOptions.typeChat = "canal";
            canalOptions.isHiddenChat = e.target.hiddenChat.checked;
        }

        const formData = new FormData();
        Object.keys(canalOptions).forEach(key => {
            formData.append(key, canalOptions[key]);
        });
        formData.append('image', files);

        axios.post('/creatChat/api', formData)
            .then(function (response) {
                setData(response.data.data, "datasdasdasd")
                setLoad(false);
                setOpenModalForAddEmploys(!openModalForAddEmploys);
                setFiles(null)
                const form = document.getElementById('creatChatModalContLight'); // Замените 'yourFormId' на ID вашей формы
                    if (canalOptions.typeChat == "public") {
                            navigate("/chat/public")
                    }else if(canalOptions.typeChat == "Conversation" || canalOptions.typeChat == "canal"){
                             navigate("/chat/conversations")
                    }

                if (location.pathname === "/chat/conversations") {
                    dispatch(getItemChatAction("/getItemChat/api?filter=Conversations"));
                } else if (location.pathname === "/chat/public") {
                    dispatch(getItemChatAction("/getItemChat/api?filter=Public"));
                } else if (location.pathname === "/chat/private") {
                    dispatch(getItemChatAction("/getItemChatPrivate/api?filter=private"));
                }

                form.reset();
                closeModalFunc();
            })
            .catch(function (error) {
                console.log(error);
                setLoad(false);
            });
    }


    return (
        <>
            <CreatChatButton openModalFunc={openModalFunc} />
            {/*     // openModalForAddEmploys == true тогда откроется модальное окно */}
            <AddingParticipants openModalForAddEmploys={openModalForAddEmploys} setOpenModalForAddEmploys={setOpenModalForAddEmploys} data={data} />
            <form id="creatChatModalContLight" className={getDarkModoe.ToggleDarkModeReducer.chekced ? "creatChatModalContDark" : "creatChatModalContLight"} ref={openModal} onSubmit={creatChat} onClick={closeModal} enctype="multipart/form-data">
                <div className="creatChatModal-content">
                    <div className="creatChatModal-header">
                        <p>Новый чат</p>

                        <div onClick={closeModalFunc}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M1 1L15 15M1.00003 15L8.00003 8L15 1" stroke="#393939" strokeWidth="1.5" strokeLinecap="round" />
                            </svg>
                        </div>

                    </div>
                    <div className="uploadChatImageCreatCont">
                        <label htmlFor="uploadChatImageCreat">

                            {
                                files ?
                                    <Avatar src={URL.createObjectURL(files)} size='sm' />
                                    :
                                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36ZM18.0453 8.25C19.8818 8.24999 21.3214 8.24999 22.4635 8.37373C23.6291 8.50001 24.5734 8.76232 25.3798 9.34815C25.8679 9.70281 26.2972 10.1321 26.6518 10.6202C27.2377 11.4266 27.5 12.3709 27.6263 13.5365C27.75 14.6786 27.75 16.1182 27.75 17.9547V18.006C27.75 18.9403 27.75 19.7682 27.7348 20.5005C27.6903 22.6546 27.5217 24.1825 26.6518 25.3798C26.2972 25.8679 25.8679 26.2972 25.3798 26.6518C24.5734 27.2377 23.6291 27.5 22.4635 27.6263C21.3214 27.75 19.8818 27.75 18.0453 27.75H17.9547C16.1182 27.75 14.6786 27.75 13.5365 27.6263C12.3709 27.5 11.4266 27.2377 10.6202 26.6518C10.1498 26.3101 9.73405 25.899 9.38706 25.4327C9.37399 25.4151 9.36102 25.3975 9.34815 25.3798C8.76232 24.5734 8.50001 23.6291 8.37373 22.4635C8.24998 21.3214 8.24999 19.8818 8.25 18.0452V17.9548C8.24999 16.1182 8.24998 14.6786 8.37373 13.5365C8.50001 12.3709 8.76232 11.4266 9.34815 10.6202C9.70281 10.1321 10.1321 9.70281 10.6202 9.34815C11.4266 8.76232 12.3709 8.50001 13.5365 8.37373C14.6786 8.24999 16.1182 8.24999 17.9547 8.25H17.9548H18.0452H18.0453ZM13.698 9.865C12.6601 9.97745 12.0099 10.1926 11.5019 10.5617C11.1411 10.8238 10.8238 11.1411 10.5617 11.5019C10.1926 12.0099 9.97745 12.6601 9.865 13.698C9.75103 14.75 9.75 16.1084 9.75 18C9.75 19.8916 9.75103 21.25 9.865 22.302C9.90522 22.6732 9.95858 22.9948 10.0274 23.2781C10.3028 22.7487 10.531 22.359 10.8014 22.0261C11.8664 20.7154 13.4537 19.939 15.1422 19.9032C15.774 19.8897 16.4471 20.0244 17.5462 20.2444L17.6711 20.2694C17.8432 19.9843 17.9951 19.7558 18.1537 19.5606C20.0651 17.2087 23.4737 16.7441 25.9448 18.4986C26.0435 18.5687 26.1438 18.6476 26.2497 18.7373C26.25 18.5006 26.25 18.255 26.25 18C26.25 16.1084 26.249 14.75 26.135 13.698C26.0225 12.6601 25.8074 12.0099 25.4383 11.5019C25.1762 11.1411 24.8589 10.8238 24.4981 10.5617C23.9901 10.1926 23.3399 9.97745 22.302 9.865C21.25 9.75103 19.8916 9.75 18 9.75C16.1084 9.75 14.75 9.75103 13.698 9.865ZM26.2273 20.7882C25.6104 20.1728 25.3239 19.8974 25.0764 19.7217C23.25 18.4249 20.7305 18.7683 19.3178 20.5066C19.1615 20.699 18.9887 20.9758 18.6693 21.5345C18.5685 21.7108 18.4556 21.9105 18.3256 22.1404L16.0069 26.2428C16.5984 26.2498 17.2582 26.25 18 26.25C19.8916 26.25 21.25 26.249 22.302 26.135C23.3399 26.0225 23.9901 25.8074 24.4981 25.4383C24.8589 25.1762 25.1762 24.8589 25.4383 24.4981C25.972 23.7636 26.1701 22.7589 26.2273 20.7882ZM14.3181 26.1876C14.3269 26.1685 14.3365 26.1496 14.3471 26.131L16.8842 21.6422C15.9843 21.4647 15.5589 21.3947 15.174 21.4028C13.926 21.4293 12.7528 22.0031 11.9656 22.972C11.6842 23.3184 11.4519 23.7732 10.8901 24.8968C11.0759 25.0962 11.2807 25.2776 11.5019 25.4383C12.0099 25.8074 12.6601 26.0225 13.698 26.135C13.8937 26.1562 14.0999 26.1735 14.3181 26.1876ZM14.25 15C14.25 13.4812 15.4812 12.25 17 12.25C18.5188 12.25 19.75 13.4812 19.75 15C19.75 16.5188 18.5188 17.75 17 17.75C15.4812 17.75 14.25 16.5188 14.25 15ZM17 13.75C16.3096 13.75 15.75 14.3096 15.75 15C15.75 15.6904 16.3096 16.25 17 16.25C17.6904 16.25 18.25 15.6904 18.25 15C18.25 14.3096 17.6904 13.75 17 13.75Z" fill="#3B79F6" />
                                    </svg>

                            }
                        </label>
                        <label htmlFor="uploadChatImageCreat">Загрузить аватар чата</label>
                        {
                            files && <div onClick={() => setFiles(null)}><p>Удалить</p></div>
                        }

                        <input type="file" name="image" id="uploadChatImageCreat" onChange={handleChange} placeholder="asd" className="uploadChatImageCreat" />
                    </div>
                    <div className="writeNameCont">
                        <p>Название</p>
                        <input type="text" placeholder="Например,  “Упрости”" name="chatName" required />
                    </div>
                    <div className="selectTypeCont">
                        <label htmlFor="Conversation" className="Conversation" ref={ConversationConnversion}>
                            <div>
                                <p className="ConversationName">Беседа</p>
                                <p className="AnyoneCanWrite">Могут писать все</p>
                            </div>
                            <input type="radio" id="Conversation" disabled={isPublic} name="creatChatType" value="Conversation" />
                        </label>
                        <label htmlFor="canal" className="canal" ref={disableDivCanal}>
                            <div>
                                <p className="nameCanal">Канал</p>
                                <p className="EditorsWrite">Пишут редакторы</p>
                            </div>

                            <input type="radio" id="canal" name="creatChatType" value="canal" disabled={isPublic} defaultChecked />

                        </label>

                    </div>
                    <div className="MakeItClosedCont">
                        <div>
                            <div className="iconCont">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M10 11.25C8.48125 11.25 7.25003 12.4812 7.25003 14C7.25003 15.5188 8.48125 16.75 10 16.75C11.5188 16.75 12.75 15.5188 12.75 14C12.75 12.4812 11.5188 11.25 10 11.25ZM8.75003 14C8.75003 13.3096 9.30968 12.75 10 12.75C10.6904 12.75 11.25 13.3096 11.25 14C11.25 14.6904 10.6904 15.25 10 15.25C9.30968 15.25 8.75003 14.6904 8.75003 14Z" fill="#858C99" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M10 0.25C6.8244 0.25 4.25003 2.82436 4.25003 6V6.52281L4.22319 6.53142C2.47267 7.1002 1.10024 8.47263 0.531458 10.2232C0.249584 11.0907 0.249748 12.1319 0.250016 13.8382V14.1618C0.249748 15.8681 0.249584 16.9093 0.531458 17.7768C1.10024 19.5274 2.47267 20.8998 4.22319 21.4686C5.0907 21.7505 6.13191 21.7503 7.83817 21.75H12.1619C13.8682 21.7503 14.9094 21.7505 15.7769 21.4686C17.5274 20.8998 18.8998 19.5274 19.4686 17.7768C19.7505 16.9093 19.7503 15.8681 19.75 14.1619V13.8381C19.7503 12.1319 19.7505 11.0907 19.4686 10.2232C18.8998 8.47263 17.5274 7.1002 15.7769 6.53142L15.75 6.52281V6C15.75 2.82436 13.1757 0.25 10 0.25ZM7.91606 6.25C7.03686 6.24997 6.33514 6.24994 5.75003 6.28306V6C5.75003 3.65279 7.65282 1.75 10 1.75C12.3472 1.75 14.25 3.65279 14.25 6V6.28306C13.6649 6.24994 12.9632 6.24997 12.084 6.25H7.91606ZM5.12463 7.85329C5.72223 7.75262 6.52818 7.75 8.00003 7.75H12C13.4719 7.75 14.2778 7.75262 14.8754 7.85329C15.0407 7.88113 15.1832 7.91571 15.3134 7.95801C16.6072 8.37841 17.6216 9.39282 18.042 10.6867C18.2408 11.2984 18.25 12.0803 18.25 14C18.25 15.9197 18.2408 16.7016 18.042 17.3133C17.6216 18.6072 16.6072 19.6216 15.3134 20.042C14.7016 20.2407 13.9197 20.25 12 20.25H8.00003C6.08038 20.25 5.29842 20.2407 4.68671 20.042C3.39285 19.6216 2.37844 18.6072 1.95804 17.3133C1.75929 16.7016 1.75003 15.9197 1.75003 14C1.75003 12.0803 1.75929 11.2984 1.95804 10.6867C2.37844 9.39282 3.39285 8.37841 4.68671 7.95801C4.81688 7.91571 4.95938 7.88113 5.12463 7.85329Z" fill="#858C99" />
                                </svg>
                            </div>
                            <p className="Make-it-closed-pp">Сделать закрытым</p>
                        </div>
                        <div className="notificationCreatChat">
                            <p>Только приглашенные участники будут иметь доступ к чату. Можно изменить позже.</p>
                            <Switch size='sm' name="hiddenChat" isChecked={chatIsClosedSweetch} onChange={() => setChatIsClosedSweetch(!chatIsClosedSweetch)} />


                        </div>
                    </div>
                    <div className="publicSweetch">
                        <div>
                            <div className="publicIconCont">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewBox="0 0 24 17" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M12 0C9.92893 0 8.25 1.67893 8.25 3.75C8.25 5.82107 9.92893 7.5 12 7.5C14.0711 7.5 15.75 5.82107 15.75 3.75C15.75 1.67893 14.0711 0 12 0ZM9.75 3.75C9.75 2.50736 10.7574 1.5 12 1.5C13.2426 1.5 14.25 2.50736 14.25 3.75C14.25 4.99264 13.2426 6 12 6C10.7574 6 9.75 4.99264 9.75 3.75Z" fill="#858C99" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M9 9C6.92893 9 5.25 10.6789 5.25 12.75C5.25 14.8211 6.92893 16.5 9 16.5H15C17.0711 16.5 18.75 14.8211 18.75 12.75C18.75 10.6789 17.0711 9 15 9H9ZM6.75 12.75C6.75 11.5074 7.75736 10.5 9 10.5H15C16.2426 10.5 17.25 11.5074 17.25 12.75C17.25 13.9926 16.2426 15 15 15H9C7.75736 15 6.75 13.9926 6.75 12.75Z" fill="#858C99" />
                                    <path d="M7.75214 6.38865C7.59441 6.13527 7.29846 6 7 6C5.75736 6 4.75 4.99264 4.75 3.75C4.75 2.50736 5.75736 1.5 7 1.5C7.29846 1.5 7.59441 1.36473 7.75214 1.11135C7.75912 1.10014 7.76613 1.08896 7.7732 1.07782C8.0358 0.663308 7.90275 0.0764006 7.415 0.0227032C7.27873 0.00770099 7.14027 0 7 0C4.92893 0 3.25 1.67893 3.25 3.75C3.25 5.82107 4.92893 7.5 7 7.5C7.14027 7.5 7.27873 7.4923 7.415 7.4773C7.90275 7.4236 8.0358 6.83669 7.7732 6.42218C7.76614 6.41104 7.75912 6.39986 7.75214 6.38865Z" fill="#858C99" />
                                    <path d="M4.70829 14.3169C4.59477 14.1275 4.39439 14 4.17359 14H4C2.75736 14 1.75 12.9926 1.75 11.75C1.75 10.5074 2.75736 9.5 4 9.5H4.17359C4.39439 9.5 4.59477 9.37252 4.70829 9.18313C4.98539 8.72082 4.68468 8 4.14569 8H4C1.92893 8 0.25 9.67893 0.25 11.75C0.25 13.8211 1.92893 15.5 4 15.5H4.14569C4.68469 15.5 4.98539 14.7792 4.70829 14.3169Z" fill="#858C99" />
                                    <path d="M16.2268 6.42218C15.9642 6.83669 16.0973 7.4236 16.585 7.4773C16.7213 7.4923 16.8597 7.5 17 7.5C19.0711 7.5 20.75 5.82107 20.75 3.75C20.75 1.67893 19.0711 0 17 0C16.8597 0 16.7213 0.00770104 16.585 0.0227034C16.0973 0.0764008 15.9642 0.663307 16.2268 1.07782C16.2339 1.08896 16.2409 1.10014 16.2479 1.11134C16.4056 1.36472 16.7015 1.5 17 1.5C18.2426 1.5 19.25 2.50736 19.25 3.75C19.25 4.99264 18.2426 6 17 6C16.7015 6 16.4056 6.13527 16.2479 6.38865C16.2409 6.39986 16.2339 6.41104 16.2268 6.42218Z" fill="#858C99" />
                                    <path d="M19.2917 14.3169C19.0146 14.7792 19.3153 15.5 19.8543 15.5H20C22.0711 15.5 23.75 13.8211 23.75 11.75C23.75 9.67893 22.0711 8 20 8H19.8543C19.3153 8 19.0146 8.72082 19.2917 9.18313C19.4052 9.37252 19.6056 9.5 19.8264 9.5H20C21.2426 9.5 22.25 10.5074 22.25 11.75C22.25 12.9926 21.2426 14 20 14H19.8264C19.6056 14 19.4052 14.1275 19.2917 14.3169Z" fill="#858C99" />
                                </svg>
                            </div>
                            <p>Публичный</p>
                        </div>
                        <div>
                            <p>Доступ к чату могут иметь все пользователи. Изменить позже невозможно.</p>
                            <Switch size='sm' onChange={sweetch} />

                        </div>

                    </div>

                    <div className="creatChatBtnFooterCont">
                        {
                            load ?
                                <div className="custom-loaderCreatChat"></div>

                                :
                                <button>Создать канал</button>
                        }

                    </div>
                </div>

            </form>
        </>
    )
}